module.exports = __webpack_public_path__ + "static/media/Better customer engagements.966db92e.png";